import {Navigate, Outlet} from "react-router-dom";


export interface ProtectedRouteProps {
    isAllowed: boolean;
    redirectPath: string;
    children?: React.ReactNode;
}


export default function ProtectedRoute({isAllowed, redirectPath, children}: Readonly<ProtectedRouteProps>) {
    if (!isAllowed) {
        return <Navigate to={redirectPath} replace/>;
    }

    return children || <Outlet/>;
}